import { useState } from 'react';
import { useParams } from 'react-router';
import { CapabilityDetailLayout, WORKING_COPY_ID } from '@/components/capability-detail/CapabilityDetailLayout';
import { CapabilityPlaceholder } from '@/components/capability-detail/CapabilityPlaceholder';

export default function DomainTypeDetailPage() {
    const { name } = useParams();
    const [selectedRevisionId, setSelectedRevisionId] = useState(WORKING_COPY_ID);

    return (
        <CapabilityDetailLayout
            typeLabel="Domain Type"
            selectedRevisionId={selectedRevisionId}
            onRevisionChange={setSelectedRevisionId}
        >
            <CapabilityPlaceholder typeLabel="Domain Type" capabilityName={name ?? ''} />
        </CapabilityDetailLayout>
    );
}
